import { useQuery } from "react-query";
import axios from "infra/http";


function useHistoricoCobrancaObservacao(id?: string) {
  return useQuery(
    [`/v1/historico-cobranca/${id}/observacao`],
    async () => {
      const res = await axios.get<{id: string; observacao: string}>(`/v1/historico-cobranca/${id}/observacao`, {
      });

      return res.data;
    },
    {enabled: !!id}
  );
}

export default useHistoricoCobrancaObservacao;
